export default "__VITE_ASSET__CUCr49Sd__"